import React from 'react';

import { Box } from '@leagueplatform/genesis-core';
import {
  LiveChatContainer as LeagueLiveChatContainer,
  useLiveChatRepository,
} from '@leagueplatform/live-chat';

type LiveChatContainerProps = {
  isPrivatePage: boolean;
};

export const LiveChatContainer: React.FC<LiveChatContainerProps> = ({
  isPrivatePage,
}) => {
  const { liveChatState } = useLiveChatRepository();
  const { chatSessionState } = liveChatState;
  const shouldShowLiveChatContainer =
    chatSessionState && chatSessionState !== 'NotStarted' && isPrivatePage;

  if (!shouldShowLiveChatContainer) return null;

  return (
    <Box>
      <LeagueLiveChatContainer />
    </Box>
  );
};
